import { Delete } from '../../../../Icons/components/Delete';
import { IconButton } from '../../../IconButton';
import { type ChipButtonItem } from '../../types/types';
import { ChipItem } from '../../styles';
import { ItemButtonStyled, ItemDeleteButtonWrapper, ItemRowStyled } from './styles';

type SingleSelectItemsProps = {
  items: ChipButtonItem[];
  selectedValues: string[];
  onChange?: (selectedValues: string[]) => void;
  onSelect: () => void;
  onDeleteItem?: (value: string) => void;
  deleteItemAriaLabel?: (item: ChipButtonItem) => string;
  children?: React.ReactNode;
};

export const SingleSelectItems = ({
  items,
  selectedValues,
  onChange,
  onSelect,
  onDeleteItem,
  deleteItemAriaLabel,
  children,
}: SingleSelectItemsProps) => {
  return (
    <>
      {items.map((item) => {
        const selected = selectedValues.includes(item.value);

        return (
          <ChipItem key={item.value} compact>
            <ItemRowStyled selected={selected}>
              <ItemButtonStyled
                type="button"
                selected={selected}
                onClick={() => {
                  onChange?.(selected ? [] : [item.value]);
                  onSelect();
                }}
              >
                {item.label}
              </ItemButtonStyled>
              {onDeleteItem && (
                <ItemDeleteButtonWrapper>
                  <IconButton
                    variant="secondary"
                    aria-label={deleteItemAriaLabel?.(item)}
                    onClick={() => {
                      onDeleteItem(item.value);
                    }}
                  >
                    <Delete height="20px" width="20px" />
                  </IconButton>
                </ItemDeleteButtonWrapper>
              )}
            </ItemRowStyled>
          </ChipItem>
        );
      })}

      {children}
    </>
  );
};
